// Bottom Navigation Component for Mobile
import Icon from '../common/Icon';
import './BottomNav.css';

export default function BottomNav({ currentView, setCurrentView }) {
    const navItems = [
        { id: 'notes', label: 'Notes', icon: 'FileText' },
        { id: 'settings', label: 'Settings', icon: 'Settings' },
        { id: 'account', label: 'Account', icon: 'User' },
    ];

    return (
        <nav className="bottom-nav">
            {navItems.map(item => (
                <button
                    key={item.id}
                    className={`bottom-nav-item ${currentView === item.id ? 'active' : ''}`}
                    onClick={() => setCurrentView(item.id)}
                >
                    <span className="bottom-nav-icon">
                        <Icon name={item.icon} size="md" />
                    </span>
                    <span className="bottom-nav-label">{item.label}</span>
                </button>
            ))}
        </nav>
    );
}
